import { createReducer, on } from "@ngrx/store";
import { CalendarioPublicacoesOutputDto } from "src/app/domain/DTOs/output/calendario-publicacoes.output.dto";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { obterCalendarioPublicacao, obterCalendarioPublicacaoSuccess, obterCalendarioPublicacaoFailure, obterCalendarioPublicacaoFinish } from "../actions/obter-calendarios-publicacoes.action";

export interface ObterCalendariosPublicacoesState {
  response: EstruturaRetornoDadosOutputDto<CalendarioPublicacoesOutputDto> | null;
  error: string[] | null;
}

export const initialState: ObterCalendariosPublicacoesState = {
  response: null,
  error: null,
};

export const ObterCalendariosPublicacoesReducer = createReducer(
  initialState,
  on(obterCalendarioPublicacao, state => ({ ...state, error: null })),
  on(obterCalendarioPublicacaoSuccess, (state, { response }) => ({ ...state, response, error: null })),
  on(obterCalendarioPublicacaoFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
  on(obterCalendarioPublicacaoFinish, state => ({ ...state, response: null, error: null }))
);
